import React from 'react';
import {
  Box,
  Container,
  Typography,
  Stack,
  Button,
  Paper,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const Contact = () => {
  return (
    <Box sx={{ py: { xs: 8, md: 12 } }}>
      <Container maxWidth="md">
        {/* Header */}
        <Typography
          variant="h3"
          component="h1"
          sx={{ fontWeight: 600, mb: 1, textAlign: 'center' }}
        >
          Questions? We have answers.
        </Typography>
        <Typography
          variant="body1"
          color="text.secondary"
          sx={{ mb: 6, textAlign: 'center', maxWidth: 640, mx: 'auto' }}
        >
          We&apos;re here to help. Reach out for support, share feedback, or learn more about how
          Rinovo works.
        </Typography>

        {/* Contact cards */}
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={3}
          sx={{ mb: 8 }}
        >
          <Box sx={{ flex: 1 }}>
            <Paper
              elevation={0}
              sx={{
                p: 3,
                borderRadius: 3,
                border: '1px solid rgba(15, 23, 42, 0.08)',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
              }}
            >
              <Box>
                <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
                  Contact our team
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                  Need assistance or have a question? Email us and we&apos;ll get back to you.
                </Typography>
              </Box>
              <Button
                component="a"
                href="mailto:rinovoco@gmail.com?subject=Assistance"
                variant="contained"
                color="primary"
                sx={{ mt: 1 }}
              >
                Email us
              </Button>
            </Paper>
          </Box>

          <Box sx={{ flex: 1 }}>
            <Paper
              elevation={0}
              sx={{
                p: 3,
                borderRadius: 3,
                border: '1px solid rgba(15, 23, 42, 0.08)',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
              }}
            >
              <Box>
                <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
                  Leave feedback
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                  Your feedback helps us prioritize new features and improve search results.
                </Typography>
              </Box>
              <Button
                component="a"
                href="mailto:rinovoco@gmail.com?subject=Feedback"
                variant="outlined"
                color="primary"
                sx={{ mt: 1 }}
              >
                Share feedback
              </Button>
            </Paper>
          </Box>

          <Box sx={{ flex: 1 }}>
            <Paper
              elevation={0}
              sx={{
                p: 3,
                borderRadius: 3,
                border: '1px solid rgba(15, 23, 42, 0.08)',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
              }}
            >
              <Box>
                <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
                  Partner with Rinovo
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                  Interested in collaborating or exploring partnerships? Let&apos;s talk.
                </Typography>
              </Box>
              <Button
                component="a"
                href="mailto:rinovoco@gmail.com?subject=Partner%20with%20Rinovo"
                variant="outlined"
                color="primary"
                sx={{ mt: 1 }}
              >
                Partner with us
              </Button>
            </Paper>
          </Box>
        </Stack>

        {/* FAQ section */}
        <Box>
          <Typography
            variant="h4"
            component="h2"
            sx={{ fontWeight: 600, mb: 3, textAlign: 'left' }}
          >
            Frequently Asked Questions
          </Typography>

          <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant="body1">
                What does Rinovo do?
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography variant="body2" color="text.secondary">
                Rinovo helps you find similar home products to the ones you love, surfacing options
                across stores based on an image, description, or link you provide.
              </Typography>
            </AccordionDetails>
          </Accordion>

          <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant="body1">
                Do I need an account to use Rinovo?
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography variant="body2" color="text.secondary">
                You can try searches without an account, but creating one lets you save items,
                boards, and come back to your sessions.
              </Typography>
            </AccordionDetails>
          </Accordion>

          <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant="body1">
                Where do I actually buy the products I find?
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography variant="body2" color="text.secondary">
                Rinovo links you to third-party retailers. When you&apos;re ready to purchase,
                you&apos;ll complete the transaction directly on the retailer&apos;s website.
              </Typography>
            </AccordionDetails>
          </Accordion>

          <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant="body1">
                How can I share feedback or report an issue?
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography variant="body2" color="text.secondary">
                You can email us anytime at rinovoco@gmail.com with ideas, questions, or bug
                reports. We read every message and use your input to improve Rinovo.
              </Typography>
            </AccordionDetails>
          </Accordion>
        </Box>
      </Container>
    </Box>
  );
};

export default Contact;

